import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(id_integration) {
    const response = await api.fetch(
      `/api/v2/booking/validation/id_integration/${id_integration}`,
      {
        method: 'GET',
      },
    )
    return await handleResponse(response)
  }
}
